import './App.css';
import { Allroutes } from './Component/Allroutes';

function App() {
  return (
    <div className="App">
  
    <Allroutes/>
    </div>
  );
}

export default App;
